import React, { Component } from 'react';
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress';
import {
  Table,
  TableBody,
  TableCell,
  TableSortLabel,
  TableContainer,
  TableHead,
  Paper,
  TableRow,
} from "@mui/material";

class ListViewTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasVerticalScrollbar: false,
    }
    this.tableRef = React.createRef();
    this.scrollTimeout = null;
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.tableRef.current.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      const table = this.tableRef.current;
      // 
      // const { filters } = this.state;
      if (this.tableRef.current.scrollTop + this.tableRef.current.clientHeight >= table.scrollHeight - 50) {
        this.props.handleScroll()
      }
    }, 200);

  }
  componentDidUpdate
    () {
    if (this.tableRef.current) {
      const element = this.tableRef.current;
      const hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
      if (this.state.hasVerticalScrollbar !== hasVerticalScrollbar) {
        this.setState({ hasVerticalScrollbar });
      }
    }
  }

  render() {
    const columnHeaders = this.props?.columns;
    const sortConfig = this.props?.sortConfig;
    const groupedData = this.props?.data || [];
    const normalData = this.props?.value || [];
    const collapsedGroups = this.props?.collapsedGroups || {};
    const groupedName = this.props?.groupedName;
    const isLoader = this.props?.isLoader;
    // console.log(normalData);
    

    return (
      <div className='table-wrapper'>
        <TableContainer component={Paper} className={`table_change removeborder plr mr-scroll`} sx={{ marginTop: 2 }} ref={this.tableRef}>
          <Table className={`tableborder table-wid-2 ${this.state.hasVerticalScrollbar ? "normalwidth" : "scrolerwidth"}`} stickyHeader aria-label="sticky table">
            <TableHead sx={{ position: "sticky", top: 0, zIndex: 1, "& .MuiTableCell-root": { backgroundColor: "background.paper" }, }}>
              <TableRow className="tabel-head">
                {columnHeaders.map((column) => (
                  <TableCell className="table-header-padding" key={column.key} width={column.width} size='small'>
                    <TableSortLabel
                      className="table_label"
                      active={sortConfig.sortBy === column.key}
                      direction={
                        sortConfig.sortByOrder
                      }
                      onClick={() => this.props?.handleSort(column.key)}
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {groupedName !== null ?
              <TableBody>
                {(normalData.length > 0) ?
                  (Object.keys(groupedData).map((groupName) => (
                    groupedData[groupName].length > 0 &&
                    (<React.Fragment key={groupName}>
                      <TableRow>
                        <TableCell className="table-cell-padding" colSpan={columnHeaders.length + 1}>
                          <span
                            onClick={() => this.props?.toggleGroup(groupName)}
                            className={`group-toggle cursor-pointer ${collapsedGroups[groupName] ? 'collapsed' : ''}`}
                          >
                            {!collapsedGroups[groupName] ? <KeyboardArrowRight /> : <KeyboardArrowDown />}
                          </span>
                          {`${groupedName}: ${groupName} ( ${groupedData[groupName].length} )`}
                        </TableCell>
                      </TableRow>
                      {collapsedGroups[groupName] &&
                        <>
                          {groupedData[groupName].map((row) => (
                            <TableRow key={row.id}>
                              {columnHeaders.map((column) => (
                                (column.key === "title" || column.key === "fullName") ?
                                  <TableCell width={column.width} className="table-cell-padding" key={column.key}><span className='table-link' onClick={() => this.props.handleChangeId(row.id)}>{row[column.key]}</span></TableCell>
                                  :
                                  <TableCell width={column.width} className="table-cell-padding" key={column.key}>{column.key === "skillSetMandatory" ? row[column.key]?.map((data) => (data.skillSetName))?.join(',') : row[column.key]}</TableCell>
                              ))}
                            </TableRow>
                          ))}
                          {isLoader && <TableRow className='border-no'><TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" algin="center"><CircularProgress color="primary" className="text-center" /></TableCell></TableRow>}
                        </>}
                    </React.Fragment>)
                  ))) : (normalData.length === 1 || isLoader) ? <TableRow><TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" algin="center"><CircularProgress color="primary" className="text-center" /></TableCell></TableRow>
                    : <TableRow ><TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" algin="center">No records to display</TableCell></TableRow>
                }
              </TableBody>
              :
              <TableBody>
                {
                  (normalData.length > 0) ?
                    <>
                      {normalData.map((row) => (
                        <TableRow key={row.id}>
                          {columnHeaders.map((column) => (
                            <TableCell width={column.width} className="table-cell-padding" key={column.key}>
                              {column.key === 'applications' ? (
                                // row.applications.length > 0 ?
                                //   row.applications.map(app => (
                                //     <img key={app.id} src={app.minLogo || app.maxLogo} alt={app.name} style={{ width: 50, height: 50 }} />
                                //   )) :
                                   '-'
                              ) : (
                                (column.key === "email") ?
                                  <span className='table-link' onClick={() => this.props.handleChangeId(row.id)}>{row[column.key] === null ? "-" : row[column.key]}</span> :
                                  //(column.key === "skillSetMandatory" ? row[column.key]?.map((data) => (data.skillSetName))?.join(',') : 
                                  (column.key === "userStatus" ?
                                    (row[column.key] === "Active" ? <span style={{ color: "green" }}>Active</span> : <span style={{ color: "red" }}>InActive</span>) :
                                    (column.key === "lastLoginDate" ?
                                      (row[column.key] ? <span>{row[column.key]}</span> : <span style={{ paddingLeft: '32px' }}>-</span>) :
                                      // row[column.key]
                                      (row[column.key] === "Active" ? 
                                        <span style={{ color: 'green' }}>{row[column.key]}</span> :
                                        (row[column.key] === "Pending" ?
                                            <span style={{ color: 'orange' }}>{row[column.key]}</span> :
                                            <span>{row[column.key]}</span>
                                        )
                                    )
                                    )
                                  )
                                //)
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                      {isLoader && <TableRow className='border-no'><TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" algin="center"><CircularProgress color="primary" className="text-center" /></TableCell></TableRow>}
                    </> : (normalData.length === 1 || isLoader) ? <TableRow><TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" algin="center"><CircularProgress color="primary" className="text-center" /></TableCell></TableRow>
                      : <TableRow className='border-no'><TableCell colSpan={columnHeaders.length + 1} className="group-header mt-3 text-center" algin="center">No records to display</TableCell></TableRow>
                }
              </TableBody>
            }
          </Table>
        </TableContainer>
        {this.state.hasVerticalScrollbar && (
          <div className=""></div>
        )}
      </div>
      // </Paper>
    );
  }
}

export default ListViewTable;
